class Data {
  access_token: string;
  redirect: string;
  third_party: boolean;
  user: any;
}

export class AuthResponse {
  data: Data;
}
